/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as GraphDefs from './defs.defs.js'

const $nsid = 'app.bsky.graph.getStarterPacksWithMembership'

export { $nsid }

/** Enumerates the starter packs created by the session user, and includes membership information about `actor` in those starter packs. Requires auth. */
const main = l.query(
  $nsid,
  l.params({
    actor: l.string({ format: 'at-identifier' }),
    limit: l.optional(
      l.withDefault(l.integer({ minimum: 1, maximum: 100 }), 50),
    ),
    cursor: l.optional(l.string()),
  }),
  l.jsonPayload({
    cursor: l.optional(l.string()),
    starterPacksWithMembership: l.array(
      l.ref<StarterPackWithMembership>(
        (() => starterPackWithMembership) as any,
      ),
    ),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output

/** A starter pack and an optional list item indicating membership of a target user to that starter pack. */
type StarterPackWithMembership = {
  $type?: 'app.bsky.graph.getStarterPacksWithMembership#starterPackWithMembership'
  starterPack: GraphDefs.StarterPackView
  listItem?: GraphDefs.ListItemView
}

export type { StarterPackWithMembership }

/** A starter pack and an optional list item indicating membership of a target user to that starter pack. */
const starterPackWithMembership = l.typedObject<StarterPackWithMembership>(
  $nsid,
  'starterPackWithMembership',
  l.object({
    starterPack: l.ref<GraphDefs.StarterPackView>(
      (() => GraphDefs.starterPackView) as any,
    ),
    listItem: l.optional(
      l.ref<GraphDefs.ListItemView>((() => GraphDefs.listItemView) as any),
    ),
  }),
)

export { starterPackWithMembership }
